import React, { useEffect, useState } from "react";
import { AttributeGroupDataProvider } from "./index";
import { attributeUUID } from "shared/attribute-uuid";
import { guidGenerator } from "shared/helpers";

const AttributeGroupData = (props) => {
    const [data, setData] = useState({});

    useEffect(() => {
        //TODO: Check diff
        if (props.defaultValue) {
            const addresses = props.defaultValue[attributeUUID.addressInfo];
            const prepInstructions = props.defaultValue[attributeUUID.prepInstructions];

            const updatedAttributeUUID = addresses ? attributeUUID.addressInfo : prepInstructions ? attributeUUID.prepInstructions : null;

            const newData = addresses ? addresses : prepInstructions ? prepInstructions : null;
            const newList = newData?.map((item) => {
                return {
                    ...item,
                    id: guidGenerator(),
                };
            });
            setData({
                ...props.defaultValue,
                [updatedAttributeUUID]: newList,
            });
        } else {
            setData({});
        }
    }, [props.defaultValue]);

    const updateMany = (values) => {
        setData((current) => {
            return {
                ...current,
                ...values,
            };
        });
    };

    const update = (attr, value) => {
        setData((current) => {
            return {
                ...current,
                [attr.uuid]: value,
            };
        });
    };

    const reset = () => {
        if (props.defaultValue) {
            return;
        }

        setData({});
    };

    return <AttributeGroupDataProvider value={{ data, update, updateMany, reset }}>{props.children}</AttributeGroupDataProvider>;
};

AttributeGroupData.defaultProps = {
    defaultValue: {},
};

export default AttributeGroupData;
